import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  killSkillList: {
    display: "grid",
    gap: 16,
    width: "100%",
    padding: "0 128px 0 72px",
    gridTemplateColumns: "repeat(auto-fill, minmax(360px, 360px))",
    boxSizing: "border-box",
    marginTop: 64,

    [theme.breakpoints.down("lg")]: {
      padding: "0 32px",
      justifyContent: "center",
    },
  },

  killSkillListItem: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    alignItems: "center",
    padding: "16px 0",
    borderRadius: 8,
    backgroundColor: "rgb(37, 39, 40)",
    cursor: "pointer",
    transition: "background-color 0.2s",
    maxWidth: 360,

    "&:hover": {
      backgroundColor: "rgb(47, 49, 50)",
    },
  },

  killSkillTitle: {
    fontSize: 18,
    fontWeight: 900,
    color: "white",
    fontFamily: "Philosopher",
  },

  killSkillImage: {
    width: "100%",
    height: 200,
    objectFit: "cover",
    minWidth: 360,
    maskImage: "linear-gradient(to bottom, black 60%, transparent 100%)",
    WebkitMaskImage: "linear-gradient(to bottom, black 60%, transparent 100%)",
  },

  attemptButton: {
    background: "linear-gradient(135deg, rgb(91, 176, 95), rgb(78, 166, 112))",
    fontFamily: "Philosopher",
    fontWeight: 900,
    borderRadius: 12,
    textTransform: "none",

    "&:disabled": {
      opacity: 0.7,
    },
  },

  killSkillListItemFooter: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    padding: "0 16px",
    marginTop: -24,
    boxSizing: "border-box",
    alignItems: "center",
  },

  killSkillListItemFooterText: {
    display: "flex",
    flexDirection: "column",
    color: "white",
    alignItems: "center",

    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
    },
  },

  successChanceText: {
    fontFamily: "Philosopher",
    fontWeight: 900,
    color: "white",
    fontSize: 16,
  },

  successChanceLabelText: {
    fontFamily: "Philosopher",
    fontWeight: 700,
    color: "rgb(150, 150, 150)",
    fontSize: 12,
  },
}));

export default styles;
